import { useEffect, useState } from 'react';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { useLoadingState } from 'hooks/useLoadingState';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { getSigningUrl } from 'thunks';

interface IOnseSpanSignWidgetProps {
  onStepComplete: () => void;
}

const OneSpanSignWidget = ({ onStepComplete }: IOnseSpanSignWidgetProps) => {
  const [isLoading, setIsLoading] = useLoadingState();
  const [oneSpanSignSigningUrl, setOneSpanSignSigningUrl] = useState<string>('');
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const getOneSpanSignSigningUrl = async () => {
    try {
      setIsLoading('loading');
      const { signingUrl } = await dispatchWithUnwrap(getSigningUrl());
      setOneSpanSignSigningUrl(signingUrl);
      setIsLoading('success');
    } catch {
      setIsLoading('error');
    }
  };

  const handleSuccessSigned = async () => {
    onStepComplete();
  };

  useEffect(() => {
    getOneSpanSignSigningUrl();

    const handleReceiveMessage = (event: MessageEvent) => {
      const regex = new RegExp(/^ESL:MESSAGE/, 'gim');
      if (regex.test(event.data)) {
        // @ts-ignore
        var origin = event.origin || event.originalEvent.origin;
        var data = event.data;

        switch (data) {
          case 'ESL:MESSAGE:REGISTER':
            // @ts-ignore
            event.source?.postMessage('ESL:MESSAGE:ACTIVATE_EVENTS', origin);
            break;
          case 'ESL:MESSAGE:SUCCESS:SIGNER_COMPLETE':
            // @ts-ignore
            event.source?.postMessage(data, origin);
            handleSuccessSigned();
            break;
          default:
            // @ts-ignore
            event.source?.postMessage(data, origin);
            break;
        }
      }
    };

    window.addEventListener('message', handleReceiveMessage, false);

    return () => {
      window.removeEventListener('message', handleReceiveMessage);
    };
  }, []);

  if (isLoading === 'loading' || isLoading === 'idle') {
    return <LoaderStep />;
  }

  return (
    <iframe
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100dvh',
        zIndex: '1000',
      }}
      src={oneSpanSignSigningUrl}
    />
  );
};

export default OneSpanSignWidget;
